<recaptcha [size]="'invisible'"
           [hide]="false"
           [badge]="'bottomleft'"
           (captchaResponse)="onCaptchaResponse($event)">
</recaptcha>

<div (click)="goToMainSite()" class="new-logo-container"></div>

<div id="alreadyHaveAccount" class="already-have-account">
    <a class="upper-links" (click)="goToSignIn()" i18n>{{ 'ALREADY_HAVE_AN_ACCOUNT' | translate }}</a>
</div>

<div class="sign-up-pane">

    <div class="cnt-column-centered">
        <div [height]="27"></div>
        <div *ngIf="isAfterGetResponse" class="header-font b1Color" i18n>{{ 'COMPLETE_YOUR_ACCOUNT_CREATION' | translate }}</div>
        <div *ngIf="!isAfterGetResponse" class="header-font b1Color" i18n>{{ 'CREATE_YOUR_FREE_ACCOUNT' | translate }}</div>
        <div [height]="15"></div>


        <div [height]="5"></div>
        <ng-container *ngIf="isAfterGetResponse">
            <div class="input-container">
                <label for="password" class="label-signup" style="font-size: 14px" i18n>{{ 'CHOOSE_YOUR_PASSWORD' | translate }}</label>
                <input #passwordInput id="password" [(ngModel)]="newUser.passwordStr" (keyup)="onPasswordType()" class="default-input" type="password"
                       name="password" i18n-placeholder placeholder="Choose a secure password" maxlength="48" minlength="8" autocomplete="off" [height]="40"
                       (focusout)="validatePassword()"
                       data-testid="registerPass-edit-input">
                <div #passwordWrongMsg class="validation-failed-message">​</div>
            </div>

            <div #pwdHints class="pwdHints hideHints" data-testid="pwdHints">
                <div id="minLengthCheckMark" class="checkmark"></div><span i18n>8+{{ 'CHAR' | translate }}</span>
                <div id="specialCheckMark" class="checkmark"></div><span i18n>{{ 'NUMBER_SPECIAL' | translate }}</span>
                <div id="uppercaseCheckMark" class="checkmark"></div><span i18n>{{ 'UPPERCASE' | translate }}</span>
                <div id="lowercaseCheckMark" class="checkmark"></div><span i18n>{{ 'LOWERCASE' | translate }}</span>
            </div>
        </ng-container>

        <ng-container *ngIf="!isAfterGetResponse">
            <div class="input-container">
                <label class="label-signup" i18n>{{ 'I_AM' | translate }}. . .</label>
                <combo class="signup-btn"
                       #positionsCombo
                       i18n-hint
                       [hint]="'SELECT_YOUR_POSITION' | translate"
                       name="positionsCombo"
                       id="positions"
                       [hasOutline]="true"
                       [backgroundColor]="'white'"
                       (changeCaller)="validatePositions()"
                       [ComboData]="positions"
                       (focusout)="validatePositions()"
                       [autocomplete]="true"
                       [showImg]="true"
                       [(ngModel)]="newUser.selectedPositionId"
                       [height]="40"
                       [inputTextClass]="'large-field'"
                       [useFullWidth]="true"
                       testId="positionsCombo">
                </combo>
                <div #positionWrongMsg class="validation-failed-message">​</div>
            </div>
        </ng-container>

        <div [height]="5"></div>
        <ng-container *ngIf="isAfterGetResponse">
            <simple-btn class="signup-btn"
                        [hoverTextColor]="'white'"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [text]="signUpButtonText"
                        [textCls]="'large-btn-text-500'"
                        [height]="50"
                        [cornerRadius]="30"
                        [horizontalPadding]="20"
                        (click)="signUp()"
                        data-testid="trialTimerUpgradeBtn">
            </simple-btn>
        </ng-container>

        <ng-container *ngIf="!isAfterGetResponse">
            <simple-btn class="signup-btn"
                        [hoverTextColor]="'white'"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [text]="signUpButtonText"
                        [textCls]="'very-large-btn-text'"
                        [height]="50"
                        [cornerRadius]="30"
                        [horizontalPadding]="20"
                        (click)="signUpWithXero()"
                        data-testid="trialTimerUpgradeBtn">
            </simple-btn>
        </ng-container>

    </div>

    <div [height]="45"></div>

    <div class="terms-block">
        <div class="font14bold b1Color" i18n>
            {{ 'BY_CREATING_AN_ACCOUNT' | translate }}
            <a class="termsLabel" href="https://www.brixx.com/terms-conditions/" target="_blank">{{ 'TERMS' | translate }} &amp; {{ 'CONDITIONS' | translate }}</a>
            <span>&nbsp;&&nbsp;</span><a class="termsLabel" href="https://www.brixx.com/privacy-policy/" target="_blank">{{ 'PRIVACY_POLICY' | translate }}</a>
        </div>

        <div [height]="5"></div>

        <div id="newsCheckBoxContainer" class="checkboxContainer">
            <input [checked]="this.newUser.getNews" type="checkbox" (change)="toggleGetNews()" id="newsCheckBox" name="newsCheckBox" class="checkboxLeft newsCheckBox">
            <label for="newsCheckBox" data-testid="sendNewsCheckBox" style="width: 100%">
                <span class="b1Color" id="firstNewsRow" i18n>{{ 'BE_THE_FIRST_TO' | translate }}&nbsp;</span>
                <span class="b1Color" id="secondNewsRow" i18n>{{ 'EVOLVING_PLATFORM_AND_OUR' | translate }}</span>
            </label>
        </div>
    </div>
    <div [height]="35"></div>
</div>
<div [height]="45"></div>
<div class="footerCls b1Color" i18n>
    "{{ 'WE_LOVE_BRIXX_IT' | translate }}&nbsp;{{ 'WHICH_IS_EASY_AND' | translate }}."
</div>
<div [height]="15"></div>
<div id="reviewer" class="reviewer b1Color" i18n>{{ 'PETER_WOOD_ACCOUNTING_SERVICES' | translate }}</div>
<div [height]="15"></div>
<div class="stars"></div>
<div [height]="40"></div>